import React from 'react'
import TrendingStoreScrole from './TrendingStoreScrole'

const TrendingStores = () => {
    return (
        <div className='container-fluid' style={{marginBottom:'1.3rem'}}>
            <div className='container'>
                <TrendingStoreScrole/>
            </div>
        </div>
    )
}

export default TrendingStores